import { useEffect } from "react";

const SITE_URL = "https://rajgraphics.org";

const setMetaTag = (attr, key, content) => {
    let el = document.querySelector(`meta[${attr}="${key}"]`);
    if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, key);
        document.head.appendChild(el);
    }
    el.setAttribute("content", content);
};

export const useDocumentMeta = ({ title, description, canonical, jsonLd }) => {
    const jsonLdStr = jsonLd ? JSON.stringify(jsonLd) : "";

    useEffect(() => {
        if (title) {
            document.title = title;
            setMetaTag("property", "og:title", title);
            setMetaTag("name", "twitter:title", title);
        }
        if (description) {
            setMetaTag("name", "description", description);
            setMetaTag("property", "og:description", description);
            setMetaTag("name", "twitter:description", description);
        }
        if (canonical !== undefined) {
            const href = `${SITE_URL}${canonical}`;
            let link = document.querySelector('link[rel="canonical"]');
            if (!link) {
                link = document.createElement("link");
                link.setAttribute("rel", "canonical");
                document.head.appendChild(link);
            }
            link.setAttribute("href", href);
            setMetaTag("property", "og:url", href);
        }
        let script = document.getElementById("page-jsonld");
        if (jsonLdStr) {
            if (!script) {
                script = document.createElement("script");
                script.id = "page-jsonld";
                script.type = "application/ld+json";
                document.head.appendChild(script);
            }
            script.textContent = jsonLdStr;
        } else if (script) {
            script.remove();
        }
    }, [title, description, canonical, jsonLdStr]);
};

export default useDocumentMeta;
